import { loadLocaleMessages, getLocalesForComponent } from "@/helpers/LocaleLoaderHelper";
const context = require.context("@/components/locales", true, /\.json$/i);
const loadedLocales = loadLocaleMessages(context);
export default (component) => getLocalesForComponent(loadedLocales, component);
